module.exports = __webpack_public_path__ + "img/cases_shjd.70b4d992.jpg";